import { CultureInfo } from '../culture-info.model';
import { CultureInfoNl } from './nl';

/**
 * @ignore
 */
export const CultureInfoNlSR: CultureInfo = {
  name: 'nl-SR',
  displayName: 'Nederlands (Suriname)',
  iso3LanguageCode: 'nld',
  iso2LanguageCode: 'nl',
  ietfLanguageTag: 'nl-SR',
  parent: CultureInfoNl
};
